import axios from "axios";
import Vue from "vue";

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_SERVER
});
axiosInstance.interceptors.request.use(config => {
    //Tabiki burada token değerini local yada session storage gibi bir yerden okumamız gerekebilir
    config.headers["Authorization"] = "Bearer "+localStorage.getItem('access_token');
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers["langcode"] = localStorage.getItem('lang')
    return config;
});

axiosInstance.interceptors.response.use( async (res) => {
    if(res.config.method !== 'get')
        vm.$bvToast.toast('İşlem başarıyla gerçekleşti', {
            title: `Başarılı! `,
            variant: 'success',
            solid: true
        })
    return res;
}, async (res) => {
    const originalRequest = res.config

    if (res.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        if(localStorage.getItem('refresh_token')){
            return await axios.post( process.env.VUE_APP_API_SERVER+'refresh',{"refresh_token": localStorage.getItem('refresh_token')}).then(async res => {
                if (res.data.status === 'Success') {
                    await localStorage.setItem('access_token',res.data.data.access_token)
                    await localStorage.setItem('refresh_token',res.data.data.refresh_token)
                    axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.data.access_token;
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.data.access_token;
                    originalRequest.headers.Authorization = 'Bearer ' + res.data.data.access_token;
                    return await axios(originalRequest);
                }else{
                    localStorage.removeItem('access_token')
                    localStorage.removeItem('refresh_token')
                    window.location.href= "/Login"
                }
            }).catch((err) => {
                localStorage.removeItem('access_token')
                localStorage.removeItem('refresh_token')
                if(window.location.pathname !=="/Login"){
                    window.location.href= "/Login"
                } 
            })
        } else {
            return res.response
        }

    }else if(res.response.status === 403){
        window.location.href= "/Error/Forbidden"
    }else if(res.response.status !== 200 && res.response.status !== 201 ){
        console.log(res.response)
        if(res.response.data && res.response.data.code == 467){
          window.location.href= "/User/ChangeDefault"
        }
        vm.$bvToast.toast(res.response.data.message, {
            title: `Hata! `,
            variant: 'danger',
            solid: true
          })
    } 
    return res.response;


});
export default axiosInstance
/**/



// WEBPACK FOOTER //
// ./src/utils/axios.js